import TTXUserCtx from './ttx-user.ctx'

const TTXUserCtxProvider = ({ children, ...rest }) => {
    return <TTXUserCtx.Provider value={rest}>{children}</TTXUserCtx.Provider>
}

export default TTXUserCtxProvider
